const $inject = ['$routeParams', 'dataService'];

const lbaApiMultiSelectCtrl = function ($routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp) || [];
  vm.searchResults = [];
  vm.thisComp = angular.copy(vm.data);

  vm.refreshData = refreshData;
  vm.itemAdded = itemAdded; 
  vm.itemRemoved = itemRemoved;

  function refreshData(userSearch) {
    if(userSearch) {
      var queryString = `${vm.settings.searchFieldName}=${userSearch}`;
      if(vm.settings.searchIdValue) {
        queryString += `&${vm.settings.searchIdName}=${dataService.data.activeItem[vm.settings.searchIdValue]}`;
      }
      dataService.searchApi(vm.settings.apiVersion, vm.settings.endpoint, queryString)
        .then((data) => {
          vm.searchResults = data.map(i => i[vm.settings.valueField]);
        })
        .catch(() => {

        });
    }
  }

  function itemAdded($item) {
    vm.data.push($item);
    vm.thisComp = angular.copy(vm.data);
    _.set(dataService.data.activeItem, dataLookUp, vm.data);
  }

  function itemRemoved($item) {
    const copy = angular.copy(vm.data);
    const index = copy.indexOf($item[vm.settings.valueField] || $item);

    if (index > -1) {
      copy.splice(index, 1);
    }

    vm.data = copy;

    _.set(dataService.data.activeItem, dataLookUp, vm.data);
  }
};

lbaApiMultiSelectCtrl.$inject = $inject;

export default lbaApiMultiSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaApiMultiSelect/lbaApiMultiSelectCtrl.js